import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoodHappy = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "mood-happy" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12.75.75A10.485,10.485,0,0,0,3.833,16.775L.75,23.25l6.475-3.083A10.5,10.5,0,1,0,12.75.75Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M15.75,13.5a3,3,0,0,1-6,0Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 8.25,
			y1: 9.375,
			x2: 8.25,
			y2: 9.375
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.25,9.375a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 17.25,
			y1: 9.375,
			x2: 17.25,
			y2: 9.375
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M17.25,9.375a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375"
		})
	]
});
export default SvgMoodHappy;
